import { render, staticRenderFns } from "./generated-not-found-oddo.vue?vue&type=template&id=6368c5e4&scoped=true"
import script from "./generated-not-found-oddo.vue?vue&type=script&lang=js"
export * from "./generated-not-found-oddo.vue?vue&type=script&lang=js"
import style0 from "./generated-not-found-oddo.vue?vue&type=style&index=0&id=6368c5e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6368c5e4",
  null
  
)

export default component.exports